import React from 'react';

import { StyleSheet, View } from 'react-native';

import { ILocation } from '@rbi-ctg/frontend';
import { IRestaurant } from '@rbi-ctg/store';
import CloseButton from 'components/close-button';
import Picture from 'components/picture';
import StaticMap from 'components/static-map';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';

import { STORE_INFO_MAP_HEIGHT } from '../styled';

interface StoreInfoModalHeaderProps {
  addressLine?: string | null;
  mapPosition: ILocation;
  onClose: () => void;
  restaurantImage: IRestaurant['restaurantImage'];
  storeName: IRestaurant['name'];
}

export const StoreInfoModalHeader = ({
  addressLine,
  mapPosition,
  onClose,
  restaurantImage,
  storeName,
}: StoreInfoModalHeaderProps) => (
  <>
    <View style={styles.closeButton}>
      <CloseButton
        accessible
        accessibilityRole="button"
        accessibilityLabel={t('closeRestaurantInfoAccessibilityLabel')}
        onPress={onClose}
      />
    </View>
    <View style={styles.headerContainer}>
      {restaurantImage ? (
        <Picture image={restaurantImage} alt={storeName ?? ''} />
      ) : (
        <StaticMap
          initialZoomIOS={8000}
          position={mapPosition}
          title={storeName ?? addressLine ?? undefined}
        />
      )}
    </View>
  </>
);

const styles = StyleSheet.create({
  headerContainer: {
    height: STORE_INFO_MAP_HEIGHT,
    overflow: 'hidden',
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 1,
    backgroundColor: primitive.$white,
    borderRadius: 20,
  },
});
